import React from "react";

const TAG_OPTIONS = [
  "indoor",
  "outdoor",
  "rain_ok",
  "stroller_friendly",
  "quick",
  "booking_needed",
  "food_nearby",
  "wc",
];

function isoToDatetimeLocal(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function datetimeLocalToIso(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString();
}

function formatPreviewWhen(card) {
  if (!card?.starts_at) return "-";
  try {
    const start = new Date(card.starts_at).toLocaleString("de-CH", {
      dateStyle: "medium",
      timeStyle: "short",
    });
    if (!card.ends_at) return start;
    const end = new Date(card.ends_at).toLocaleTimeString("de-CH", {
      timeStyle: "short",
    });
    return `${start} - ${end}`;
  } catch {
    return String(card.starts_at);
  }
}

export default function SourceSubmissionCardPreview({ card, onChange, disabled }) {
  if (!card) return null;

  const set = (key, value) => {
    onChange({ ...card, [key]: value });
  };

  const toggleTag = (tag) => {
    const tags = Array.isArray(card.tags) ? [...card.tags] : [];
    const idx = tags.indexOf(tag);
    if (idx >= 0) tags.splice(idx, 1);
    else tags.push(tag);
    set("tags", tags);
  };

  return (
    <div className="source-card-preview" aria-label="Activity card preview">
      <div className="source-card-preview-layout">
        <div className="source-card-preview-visual">
          {card.image ? (
            <img src={card.image} alt="" className="source-card-preview-img" />
          ) : (
            <div className="source-card-preview-img source-card-preview-img--empty">
              No image
            </div>
          )}
          <p className="source-card-preview-when">{formatPreviewWhen(card)}</p>
        </div>
        <div className="source-card-preview-fields">
          <label>
            Title
            <input
              type="text"
              value={card.title || ""}
              disabled={disabled}
              onChange={(e) => set("title", e.target.value)}
            />
          </label>
          <label>
            Summary
            <textarea
              rows={3}
              value={card.summary || ""}
              disabled={disabled}
              onChange={(e) => set("summary", e.target.value)}
            />
          </label>
          <label>
            Location
            <input
              type="text"
              value={card.location || ""}
              disabled={disabled}
              onChange={(e) => set("location", e.target.value)}
            />
          </label>
          <div className="source-card-preview-datetimes">
            <label>
              Starts
              <input
                type="datetime-local"
                value={isoToDatetimeLocal(card.starts_at)}
                disabled={disabled}
                onChange={(e) =>
                  set("starts_at", datetimeLocalToIso(e.target.value))
                }
              />
            </label>
            <label>
              Ends
              <input
                type="datetime-local"
                value={isoToDatetimeLocal(card.ends_at)}
                disabled={disabled}
                onChange={(e) =>
                  set("ends_at", datetimeLocalToIso(e.target.value))
                }
              />
            </label>
          </div>
          <label>
            Image URL
            <input
              type="url"
              value={card.image || ""}
              disabled={disabled}
              onChange={(e) => set("image", e.target.value)}
            />
          </label>
          <label>
            Age hint
            <input
              type="text"
              value={card.age_hint || ""}
              disabled={disabled}
              onChange={(e) => set("age_hint", e.target.value)}
            />
          </label>
          <label>
            Price
            <input
              type="text"
              value={card.price_hint || ""}
              disabled={disabled}
              onChange={(e) => set("price_hint", e.target.value)}
            />
          </label>
          <label>
            Booking
            <input
              type="text"
              value={card.booking_hint || ""}
              disabled={disabled}
              onChange={(e) => set("booking_hint", e.target.value)}
            />
          </label>
          <fieldset className="source-card-preview-tags">
            <legend>Tags</legend>
            <div className="source-card-preview-tags-grid">
              {TAG_OPTIONS.map((tag) => (
                <label key={tag} className="source-card-preview-tag">
                  <input
                    type="checkbox"
                    checked={(card.tags || []).includes(tag)}
                    disabled={disabled}
                    onChange={() => toggleTag(tag)}
                  />
                  {tag.replace(/_/g, " ")}
                </label>
              ))}
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
}
